import type { IntlShape } from 'react-intl';
import type { OutreachPitchKind } from 'fym-shared/src/music24/outreach/dailyPitches';
import { pitchKindGroupName } from './pitchKindCopy';

/** "Mon Oct 31": a day of the campaign page. */
export function dayLabel(intl: IntlShape, iso: string): string {
  return intl.formatDate(new Date(iso), { weekday: 'short', month: 'short', day: 'numeric' });
}

/** "Dec 23": an end day. */
export function monthDay(intl: IntlShape, iso: string): string {
  return intl.formatDate(new Date(iso), { month: 'short', day: 'numeric' });
}

/**
 * "Spotify playlists, Apple Music and Deezer playlists": the kinds of a campaign in the head line,
 * with the group names of the kinds as they are (the brand names keep their capitals).
 */
export function kindsLine(intl: IntlShape, kinds: OutreachPitchKind[]): string {
  return intl.formatList(
    kinds.map((kind) => pitchKindGroupName(intl, kind)),
    { type: 'conjunction', style: 'narrow' }
  );
}

/**
 * The whole days that the pool lasts at the rate (rounded down), or null with no rate. A pool that
 * is smaller than one day of pitches gives 0: the card says "less than a day" (QA B05).
 */
export function poolDays(poolTotal: number, rate: number): number | null {
  return rate <= 0 ? null : Math.floor(poolTotal / rate);
}

/**
 * True when the campaign started on the artist's day of `now` (or has not started): no night with
 * a find passed since the start, so the page says "so far", not "last night" (QA B06).
 */
export function startedToday(startedAt: string | null, now: Date = new Date()): boolean {
  if (startedAt === null) {
    return true;
  }
  const start = new Date(startedAt);
  return (
    start.getFullYear() === now.getFullYear() &&
    start.getMonth() === now.getMonth() &&
    start.getDate() === now.getDate()
  );
}

/** The percent of a part, rounded; null with no total. */
export function percentOrNull(part: number, total: number): number | null {
  return total <= 0 ? null : Math.round((part / total) * 100);
}
